import { render, staticRenderFns } from "./CampusRecruitmentComp.vue?vue&type=template&id=247b9c1f&scoped=true&"
import script from "./CampusRecruitmentComp.vue?vue&type=script&lang=js&"
export * from "./CampusRecruitmentComp.vue?vue&type=script&lang=js&"
import style0 from "./CampusRecruitmentComp.vue?vue&type=style&index=0&id=247b9c1f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b9c1f",
  null
  
)

export default component.exports